import { F0AiMask } from '@factorialco/f0-react'
import { blockUserInteractionOn } from 'modules/ai_voice/lib/dom'
import './mask.css'


let mask: F0AiMask | null = null
let wrapper: HTMLDivElement | null = null

export function initAiMask(): void {
  if (mask) return

  wrapper = document.createElement('div')
  wrapper.className = 'ai-mask-wrapper'
  blockUserInteractionOn(wrapper)

  mask = new F0AiMask({
    mode: 'light',
    styles: {
      position: 'absolute',
      inset: '0'
    },
  })

  wrapper.appendChild(mask.element)
  mask.autoResize(wrapper)
  document.body.appendChild(wrapper)
}

export function disposeAiMask(): void {
  if (mask) {
    mask.dispose()
    mask = null
  }
  if (wrapper?.parentNode) {
    wrapper.parentNode.removeChild(wrapper)
    wrapper = null
  }
}

export function showAiMask(): void {
  if (wrapper) wrapper.classList.add('ai-mask-wrapper-visible')
  mask?.start()
}

export function hideAiMask(): void {
  if (wrapper) wrapper.classList.remove('ai-mask-wrapper-visible')
  mask?.pause()
}
